import { createFileRoute } from "@tanstack/react-router";
import { AssessmentPage } from "../pages/AssessmentPage";

export const Route = createFileRoute("/assessment/$appointmentId")({
  component: AssessmentPage,
});
